import consumer from "../../entrypoints/src/admin/channels/consumer";
import Swal from "sweetalert2";
import AppointmentService from "../../entrypoints/src/admin/services/appointment-service";
import MeetController from "./meet_controller";
import OnlineClassroomChannel from "../../entrypoints/src/admin/channels/online_classroom_channel";

export default class extends MeetController {
  static targets = ['meetScreen'];

  static values = {
    roomScreen: String,
    roomName: String,
    displayName: String,
    domain: String,
    token: String
  }

  connect() {
    this.initializeMeeting({
      invitees: [this.element.dataset.invitees]
    }).then((jitsiApi) => {
      this.enableMeetLobby(jitsiApi);
      this.updateOnlineGuests();
      this.closeScreenOnHangup(jitsiApi);
      this.participantLeft(jitsiApi);
    });
  }

  enableMeetLobby(jitsiApi) {
    jitsiApi.addEventListener('participantRoleChanged', async (event) => {
      if(event.role === 'moderator') {
        OnlineClassroomChannel.init(this.roomNameValue);

        jitsiApi.executeCommand('toggleLobby', true);
        let response = await AppointmentService.startedOnlineClass(this.element.dataset.appointment);

        if (response === 'empty')
          return;

        Swal.fire({
          title: '',
          text: 'Alunos da lista de presença estão sendo notificados!',
          showClass: { backdrop: 'swal2-noanimation', popup: '', },
          hideClass: { popup: '' },
          customClass: {
            cancelButton: 'btn btn-gray-primary',
            confirmButton: 'btn btn-primary mr-3'
          },
          buttonsStyling: false,
          showCancelButton: false
        })
      }
    });
  }

  updateOnlineGuests() {
    this.cable = consumer.subscriptions.create({ channel: 'UserJoinedMeetingChannel', appointment: this.element.dataset.appointment }, {
        received: (data) => {
          if (!data.guest)
            return;

          let guest = this.element.querySelector(`[data-guest="${data.guest}"]`);
          !!guest && guest.classList.toggle('online');
        }
      }
    );
  }

  closeScreenOnHangup(jitsiApi) {
    jitsiApi.on('readyToClose', async () => {
      this.element.dispatchEvent(new CustomEvent('jitsi:end', { api: jitsiApi}));
      jitsiApi.dispose();
      await AppointmentService.endOnlineClass(this.element.dataset.appointment);
      Swal.fire({
        title: '',
        text: 'A transmissão da aula foi encerrada. Gostaria de ser redirecionado para a sala de aula?',
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        showCancelButton: true,
        cancelButtonText: 'Ficar aqui',
        confirmButtonText: 'Ir para sala de aula'
      }).then((result) => {
        if (!result.value) return;
        Turbo.visit(this.element.dataset.url);
        this.meetScreenTarget.classList.add('d-flex', 'flex-column', 'justify-content-center');
        this.meetScreenTarget.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-24 h-24 text-zinc-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
          </svg>
          <div class="font-weight-400 font-xl mt-4">Aula finalizada</div>
        `;
      })
    });
  }

  participantLeft(jitsiApi) {
    jitsiApi.on('participantLeft', async (ev) => {
      console.log({ ev });
    });
  }
}
